import { AwsRum, type AwsRumConfig } from "aws-rum-web";

if (import.meta.env.VITE_STAGE === "pd") try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    identityPoolId: import.meta.env.VITE_ADMIN_RUM_IDENTITY_POOL_ID,
    endpoint: "https://dataplane.rum.ap-south-1.amazonaws.com",
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: false,
    signing: true,
  };

  const APPLICATION_ID: string = import.meta.env.VITE_ADMIN_RUM_APPLICATION_ID;
  const APPLICATION_VERSION: string = "1.0.0";
  const APPLICATION_REGION: string = "ap-south-1";

  new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}
